export const GET_REGIONS = 'sagas/region/GET_REGIONS';
export const GET_PROVINCES = 'sagas/region/GET_PROVINCES';
export const GET_COMMUNES = 'sagas/region/GET_COMMUNES';
export const GET_COURTS = 'sagas/region/GET_COURTS';
export const SET_RESOURCE = 'sagas/region/SET_RESOURCE';
